import { render } from "./MemberEvents.vue?vue&type=template&id=4d52a504"
import script from "./MemberEvents.vue?vue&type=script&lang=js"
export * from "./MemberEvents.vue?vue&type=script&lang=js"

import "./MemberEvents.vue?vue&type=style&index=0&id=4d52a504&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__